<template>
  <div v-if="isAuthenticated" class="app-header">
    <!-- Header with PrimeVue Menubar -->
    <Menubar :model="menuItems" class="p-menubar">
      <template #start>
        <div class="logo p-flex p-flex-column p-ai-center">
          <h1 class="p-m-0 p-text-bold">TestHR</h1>
        </div>
      </template>
      <template #end>
        <UserMenu @theme-changed="onThemeChanged" />
      </template>
    </Menubar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UserMenu from './UserMenu.vue'

export default {
  name: 'AppHeader',
  components: {
    UserMenu
  },
  computed: {
    ...mapState(['currentUser', 'isAuthenticated']),
    isAdmin() {
      return this.currentUser?.role === 'admin'
    },
    menuItems() {
      const items = [
        {
          label: 'Головна',
          icon: 'pi pi-home',
          command: () => this.$router.push('/dashboard')
        },
        {
          label: 'Тести',
          icon: 'pi pi-file',
          command: () => this.$router.push('/tests')
        },
        {
          label: 'Результати',
          icon: 'pi pi-chart-bar',
          command: () => this.$router.push('/results')
        }
      ]
      
      // Add admin menu item if user is admin
      if (this.isAdmin) {
        items.splice(1, 0, {
          label: 'Адміністрація',
          icon: 'pi pi-cog',
          command: () => this.$router.push('/admin')
        })
      }
      
      return items
    }
  },
  methods: {
    onThemeChanged(newTheme) {
      this.$emit('theme-changed', newTheme)
    }
  }
}
</script>

<style scoped>
.app-header {
  width: 100%;
}

/* Logo styling with PrimeVue variables */
.logo h1 {
  font-size: 1.8rem;
  font-weight: 700;
  color: white;
}

/* PrimeVue component overrides for header */
:deep(.p-menubar) {
  background: var(--primary-color);
  border: none;
  border-radius: 0;
}

:deep(.p-menubar .p-menuitem-link) {
  color: white;
  border-radius: var(--border-radius);
  transition: all 0.2s ease;
}

:deep(.p-menubar .p-menuitem-link:hover) {
  background: rgba(255, 255, 255, 0.1);
}

:deep(.p-menubar .p-menuitem-link.router-link-active) {
  background: rgba(255, 255, 255, 0.2);
}
</style>
